import { useState } from 'react';
import { apiPost } from '../../api/client.js';

const ERR_MSG = {
  invalid_current_password: 'Current password is incorrect.',
  password_too_short: 'New password must be at least 10 characters.',
  new_password_same_as_current: 'New password must be different from the current one.',
  current_and_new_password_required: 'Both fields are required.',
};

export default function Password() {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [msg, setMsg] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();
    setMsg(null);
    if (next !== confirm) {
      setMsg({ kind: 'err', text: 'The two new-password fields don’t match.' });
      return;
    }
    setSubmitting(true);
    try {
      await apiPost('/auth/change-password', { current_password: current, new_password: next });
      setMsg({ kind: 'ok', text: 'Password updated.' });
      setCurrent(''); setNext(''); setConfirm('');
    } catch (err) {
      setMsg({ kind: 'err', text: ERR_MSG[err.body?.error] || err.message });
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <div className="account-page">
      <header className="account-page-head">
        <h1>Password</h1>
        <p className="muted">Use a password you don’t use on any other site. Minimum 10 characters.</p>
      </header>

      <section className="account-section">
        <form onSubmit={handleSubmit} className="password-form" autoComplete="off">
          <label className="login-field">
            <span>Current password</span>
            <input type="password" value={current} onChange={(e) => setCurrent(e.target.value)}
              required disabled={submitting} autoComplete="current-password" />
          </label>
          <label className="login-field">
            <span>New password</span>
            <input type="password" value={next} onChange={(e) => setNext(e.target.value)}
              required minLength={10} disabled={submitting} autoComplete="new-password" />
          </label>
          <label className="login-field">
            <span>Confirm new password</span>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)}
              required minLength={10} disabled={submitting} autoComplete="new-password" />
          </label>
          {msg && <div className={`post-action-msg ${msg.kind}`}>{msg.text}</div>}
          <button type="submit" className="btn btn-primary" disabled={submitting}>
            {submitting ? 'Updating…' : 'Update password'}
          </button>
        </form>
      </section>
    </div>
  );
}
